import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { fmtDT } from "@/lib/format";

export const NotificationBell = () => {
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const load = useCallback(() => {
    api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [load]);

  const openItem = async (n) => {
    await api.post(`/notifications/${n.id}/read`).catch(() => {});
    setOpen(false);
    load();
    if (n.link) nav(n.link);
  };

  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (o) load(); }}>
      <PopoverTrigger asChild>
        <button data-testid="notifications-bell-button" className="relative flex h-10 w-10 items-center justify-center rounded-xl bg-white/80 border border-border hover:bg-white">
          <Bell className="h-5 w-5" />
          {data.unread > 0 && (
            <span data-testid="notifications-unread-count" className="absolute -right-1 -top-1 min-w-[20px] rounded-full bg-red-600 px-1.5 text-center text-[11px] font-bold leading-5 text-white">
              {data.unread > 99 ? "99+" : data.unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[340px] rounded-2xl p-0">
        <div className="flex items-center justify-between border-b px-4 py-3">
          <span className="font-bold">Notifiche</span>
          <button data-testid="notifications-read-all-button" className="text-xs font-semibold text-primary" onClick={() => api.post("/notifications/read-all").then(load)}>
            Segna tutte lette
          </button>
        </div>
        <div className="max-h-[380px] overflow-y-auto">
          {data.items.length === 0 && <p className="p-6 text-center text-sm text-muted-foreground">Nessuna notifica</p>}
          {data.items.slice(0, 20).map((n) => (
            <button key={n.id} data-testid={`notification-item-${n.id}`} onClick={() => openItem(n)}
              className={`block w-full border-b px-4 py-3 text-left hover:bg-muted/60 ${n.read ? "opacity-60" : ""}`}>
              <div className="flex items-start gap-2">
                {!n.read && <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-primary" />}
                <div className="min-w-0">
                  <p className="text-sm font-semibold leading-snug">{n.source === "toth" && <span className="text-primary">Toth · </span>}{n.title}{n.count > 1 && <span className="ml-1 text-xs text-muted-foreground">×{n.count}</span>}</p>
                  {n.body && <p className="mt-0.5 line-clamp-2 text-xs text-muted-foreground">{n.body}</p>}
                  <p className="mt-1 text-[11px] text-muted-foreground">{fmtDT(n.updated_at)}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
        <button className="w-full py-3 text-sm font-semibold text-primary" onClick={() => { setOpen(false); nav("/notifiche"); }}>Vedi tutte</button>
      </PopoverContent>
    </Popover>
  );
};
